import Leaflet from 'leaflet'
import Proj from 'proj4leaflet'

export const sweref99Tm = new Proj.CRS(
	'EPSG:3006',
	'+proj=utm +zone=33 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs',
	{
		resolutions: [8192, 4096, 2048, 1024, 512, 256, 128, 64, 32, 16, 8, 4, 2, 1, 0.5, 0.25],
    	origin: [-1200000, 8500000]
	}
)

export function fromSweref99TmToLatLng(point) {
	const latLngPoint = sweref99Tm.unproject(Leaflet.point(point))
	return [latLngPoint.lat, latLngPoint.lng]
}

export function fromLatLngToSweref99Tm(point) {
    const latlngPoint = Leaflet.latLng(point)
    const projectedPoint = sweref99Tm.project(latlngPoint)
    return [projectedPoint.x, projectedPoint.y]
}



// WEBPACK FOOTER //
// ./src/components/Leaflet/sweref99Tm.js